export default __webpack_public_path__ + "static/image-1-bfa6277429e6abe042ae1df2a9dc9575.jpg";